import * as yup from 'yup';

export const schema = yup.object().shape({
  companyName: yup.string().required('Company name is required'),
  companyNumber: yup.string().required('Company number is required'),
  companyType: yup
    .string()
    .oneOf([
      'limited_liability_company',
      'limited_liability_partnership',
      'public_limited_company',
      'other',
    ])
    .required('Company type is required'),
  startDateMonth: yup.string().required('Start trading month required'),
  startDateYear: yup
    .string()
    .required('Start trading year required')
    .min(4, 'Year required')
    .max(4, 'Invalid year'),
  last12MonthsTurnover: yup.string().required('Turnover required'),
  website: yup
    .string()
    .matches(
      /^$|((http|https):\/\/)?[a-zA-Z0-9./?:@\-_=#]+\.([a-zA-Z0-9&./?:@\-_=#])*/,
      'Please enter a valid website',
    ),
  isVatRegistered: yup
    .string()
    .oneOf(['true', 'false'])
    .required('VAT status is required'),
});

export const reductionSchema = yup.object().shape({
  companyName: yup.string().required('Company name is required'),
  companyNumber: yup.string().required('Company number is required'),
  companyType: yup
    .string()
    .oneOf([
      'limited_liability_company',
      'limited_liability_partnership',
      'public_limited_company',
      'other',
    ])
    .required('Company type is required'),
  startDateMonth: yup.string().required('Start trading month required'),
  startDateYear: yup
    .string()
    .required('Start trading year required')
    .min(4, 'Year required')
    .max(4, 'Invalid year'),
  last12MonthsTurnover: yup.string().required('Turnover required'),
});

export const minimumCompanyDataSchema = yup.object().shape({
  companyName: yup.string().required('Company name is required'),
  companyNumber: yup.string().required('Company number is required'),
  startDateMonth: yup.string().required('Start trading month required'),
  startDateYear: yup
    .string()
    .required('Start trading year required')
    .min(4, 'Year required')
    .max(4, 'Invalid year'),
  last12MonthsTurnover: yup.string().required('Turnover required'),
});
